// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Component } from "@angular/core";
import { HeaderService } from 'src/app/header.service';

@Component({
    selector: 'app-file-decryption',
    templateUrl: './file-decryption.component.html',
    styleUrls: ['./file-decryption.component.scss'],
    standalone: false
})

export class FileDecryptionComponent {

  constructor(
    private headerService: HeaderService,
  ) {
    this.headerService.showUserFilter(false);
  }

}
